import { lazy } from "react";

import { RouteType } from "types/index";
import { CORP_ACCESS_RIGHT } from "constants/accessRight";
import {
  businessEstablishmentSlugParam,
  corpSlugParam,
  jobListingSlugParam,
  organizationSlugParam,
  personalSlugParam,
  routePaths,
} from "routes/constants";

const CorporationMemberProfile = lazy(
  () => import("pages/Corporation/Member/Profile/Main/View")
);
const CorporationMemberDesiredJobPreferencesProfile = lazy(
  () => import("pages/Corporation/Member/Profile/DesiredJobPreferences/View")
);
const CorporationMemberWorkHistoryAndOtherProfile = lazy(
  () => import("pages/Corporation/Member/Profile/WorkHistoryAndOther/View")
);
const CorporationLaborManagementProfile = lazy(
  () => import("pages/Corporation/Member/Profile/LaborManagement/View")
);
const CorporationMemberCurrentStatusProfile = lazy(
  () => import("pages/Corporation/Member/Profile/CurrentStatus/View")
);
const CorporationMemberPastStatusProfile = lazy(
  () => import("pages/Corporation/Member/Profile/PastStatus/View")
);

const CorpList = lazy(() => import("pages/Corporation/List/View"));
const BusinessEstablishmentList = lazy(
  () => import("pages/Corporation/BusinessEstablishment/List/View")
);

const CorpEmployeeMember = lazy(
  () => import("pages/Corporation/Member/Employee/View")
);

const CorpStaffMember = lazy(
  () => import("pages/Corporation/Member/Staff/View")
);

const CorpCLientMember = lazy(
  () => import("pages/Corporation/Member/Client/View")
);

const OrganizationList = lazy(
  () => import("pages/Corporation/BusinessEstablishment/Organization/List/View")
);

const CorporationGeneralSetting = lazy(
  () => import("pages/Corporation/GeneralSetting/View")
);

const JobListingList = lazy(
  () => import("pages/Corporation/BusinessEstablishment/JobListing/List/View")
);

const DetailBusinessEstablishment = lazy(
  () => import("pages/Corporation/BusinessEstablishment/List/Detail/View")
);

const DetailJobListing = lazy(
  () => import("pages/Corporation/BusinessEstablishment/JobListing/Detail/View")
);

const ViewBrochure = lazy(
  () =>
    import("pages/Corporation/BusinessEstablishment/JobListing/ViewBrochure/View")
);

const DetailOrganization = lazy(
  () =>
    import("pages/Corporation/BusinessEstablishment/Organization/Detail/View")
);

const ActiveVacancies = lazy(
  () => import("pages/Corporation/ActiveVacancies/View")
);

const ExportWebAds = lazy(
  () => import("pages/Corporation/ActiveVacancies/ExportWebAds/View")
);

const CorporationPastNotes = lazy(
  () => import("pages/Corporation/PastNotes/View")
);

export const corporationRoutes: RouteType[] = [
  {
    path: routePaths.root.corp.root.root,
    element: <CorpList />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.corp.root.pCorpSlug.generalSetting.root,
    label: corpSlugParam,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.generalSetting.root,
    element: <CorporationGeneralSetting />,
    requiredAuth: true,
    label: "general_settings",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.root,
    element: <BusinessEstablishmentList />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: "business_establishments",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment
      .organizations.root,
    element: <OrganizationList />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: "organizations",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.joblisting
      .root,
    element: <JobListingList />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: "joblistings",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.detail.root,
    element: <DetailBusinessEstablishment />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: businessEstablishmentSlugParam,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.detail
      .organization.root,
    element: <OrganizationList />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: "organizations",
  },

  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.detail
      .organization.detail.root,
    element: <DetailOrganization />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: organizationSlugParam,
  },

  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.detail
      .organization.detail.jobListing.root,
    element: <JobListingList />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: "joblistings",
  },

  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.detail
      .organization.detail.jobListing.detail.root,
    element: <DetailJobListing />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: jobListingSlugParam,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.businessEstablishment.detail
      .organization.detail.jobListing.detail.brochure.root,
    element: <ViewBrochure />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
    ],
    label: "create_brochure",
  },

  {
    path: routePaths.root.corp.root.pCorpSlug.member.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.corp.root.pCorpSlug.member.employee.root,
    label: "members",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.employee.root,
    element: <CorpEmployeeMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.staff.root,
    element: <CorpStaffMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.client.root,
    element: <CorpCLientMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.pPersonal.root,
    element: <CorporationMemberProfile />,
    requiredAuth: true,
    requireAssignment: true,
    label: personalSlugParam,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.pPersonal
      .desiredJobPreferences.root,
    element: <CorporationMemberDesiredJobPreferencesProfile />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.pPersonal
      .workHistoryAndOther.root,
    element: <CorporationMemberWorkHistoryAndOtherProfile />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.pPersonal.laborManagement
      .root,
    element: <CorporationLaborManagementProfile />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.pPersonal.currentStatus
      .root,
    element: <CorporationMemberCurrentStatusProfile />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.member.pPersonal.pastStatus.root,
    element: <CorporationMemberPastStatusProfile />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.activeVacancies.root,
    element: <ActiveVacancies />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.VIEW_COMPANY_INFORMATION,
    ],
    label: "active_vacancies",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.activeVacancies.export.root,
    element: <ExportWebAds />,
    requiredAuth: true,
    requiredAccessRights: [
      CORP_ACCESS_RIGHT.CRUD_COMPANY_INFORMATION,
      CORP_ACCESS_RIGHT.PUBLISH_JOB_LISTING,
    ],
    label: "export_as_csv",
  },
  {
    path: routePaths.root.corp.root.pCorpSlug.pastNotes.root,
    element: <CorporationPastNotes />,
    requiredAuth: true,
    label: "past_notes",
  },
];
